/* Outdoors Nordic. Flyttad ur sections/on-faqs.liquid 2026-10-07.
   Lag inline och skickades med varje sidvisning som anvande sektionen.
   Laddas som modul: samma URL evalueras en gang oavsett antal taggar. */
(function () {
/* En fraga per rad, pa alla sprak och alla skarmar.
Tyska och franska fragor ar langre an svenska, och en fraga som viker sig
till tva rader gor listan ojamn. I stallet krymps just den fragan tills
den ryms - de som redan ryms rors inte alls.
  Mattningen bygger pa scrollWidth mot clientWidth. Den kraver att texten
ligger i ett eget element med white-space: nowrap och min-width: 0, annars
vagrar flex-barnet bli smalare an sitt innehall och overflodet syns aldrig.
  Ingen MutationObserver: den har kostat oss huvudtradstid forr. Skriptet gar
en gang nar typsnitten ar klara, och sen bara vid storleksandring med en
kort fordrojning. */
/* 10 px ar golvet. Tyska fragor pa 375 px behover ner till ~10,7 for att
rymmas pa en rad; med 11 som golv bots de i onodan. */
var GOLV = 10;
function passa(rot) {
var q = rot.querySelectorAll('.on-faqs__qt');
if (!q.length) return;
var i;
 /* Nollstall forst, annars mats forra korningens nedskalning. */
for (i = 0; i < q.length; i++) {
 q[i].classList.remove('on-faqs__qt--wrap');
 q[i].style.fontSize = '';
}
if (!q[0].clientWidth) return;
var bas = parseFloat(getComputedStyle(q[0]).fontSize) || 15;
 /* EN storlek for hela listan, inte en per fraga. Med en storlek per
  fraga blev polskan 15/15/15/12,8/10,4/12,1 px i samma lista: alla
  rymdes pa en rad, men raderna sag slumpartade ut. Den fraga som
  behover krympas mest far bestamma storleken for alla. */
var kvot = 1;
for (i = 0; i < q.length; i++) {
 var plats = q[i].clientWidth;
 var behov = q[i].scrollWidth;
 if (!plats || !behov) continue;
 if (behov > plats + 1) kvot = Math.min(kvot, plats / behov);
}
if (kvot >= 1) return;
 /* Rakna fram storleken i ETT steg i stallet for att stega ner en halv
  pixel i taget. Varje steg tvingar fram en ny layout. */
var px = Math.floor(bas * kvot * 10) / 10;
if (px < GOLV) px = GOLV;
satt(q, px);
 /* Avrundningen kan ligga en tiondel fel. Hogst fyra kontrollsteg. */
for (var n = 0; n < 4; n++) {
 if (!nagotSticker(q) || px <= GOLV) break;
 px = Math.max(GOLV, Math.round((px - 0.4) * 10) / 10);
 satt(q, px);
}
 /* Ryms en fraga inte ens vid golvet far just den brytas. En kapad
  fraga ar samre an en fraga pa tva rader. */
for (i = 0; i < q.length; i++) {
 if (q[i].scrollWidth > q[i].clientWidth + 1) q[i].classList.add('on-faqs__qt--wrap');
}
}
function satt(q, px) {
for (var i = 0; i < q.length; i++) q[i].style.fontSize = px + 'px';
}
function nagotSticker(q) {
for (var i = 0; i < q.length; i++) {
 if (q[i].scrollWidth > q[i].clientWidth + 1) return true;
}
return false;
}
function nar(fn) {
if (window.requestAnimationFrame) requestAnimationFrame(fn); else setTimeout(fn, 0);
}
/* Sektionen ligger langt ned pa sidan och ar inte utlagd vid sidladdning:
clientWidth ar 0, overflodet syns inte, och skriptet hoppar over precis de
fragor det skulle raddat. Uppmatt pa tyska i mobil - tre fragor stack ut
48, 82 och 114 px utan att nagot hande.
  Losningen ar nagra billiga omforsok plus en engangskoll vid forsta scroll,
samma monster som resten av temat. En IntersectionObserver provades forst
och utloste aldrig har. MutationObserver ar uteslutet, den har kostat oss
huvudtradstid forr. */
var klar = false;
function forsok() {
if (klar) return;
var alla = document.querySelectorAll('.on-faqs');
var nagotMatt = false;
for (var i = 0; i < alla.length; i++) {
 var q = alla[i].querySelector('.on-faqs__qt');
 if (q && q.clientWidth > 0) { passa(alla[i]); nagotMatt = true; }
}
if (nagotMatt) klar = true;
}
function start() {
nar(forsok);
setTimeout(forsok, 400);
setTimeout(forsok, 1200);
setTimeout(forsok, 3000);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
else start();
/* Typsnitten byter bredd nar de vaxlar fran reserv till Montserrat, sa
matningen maste goras om nar de ar pa plats. */
if (document.fonts && document.fonts.ready) {
document.fonts.ready.then(function () { klar = false; nar(forsok); });
}
/* Forsta scroll: da ar sektionen sakert utlagd aven pa langa sidor. */
var scrollKvar = true;
window.addEventListener('scroll', function () {
if (!scrollKvar) return;
scrollKvar = false;
klar = false;
nar(forsok);
}, { passive: true, once: true });
var t;
window.addEventListener('resize', function () {
clearTimeout(t);
t = setTimeout(function () { klar = false; forsok(); }, 180);
}, { passive: true });
document.addEventListener('shopify:section:load', function (e) {
if (e.target && e.target.querySelector('.on-faqs')) { klar = false; nar(forsok); }
});
  })();

